var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersBrainstorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.8,
    height: 23.55,
    viewBox: "0 0 20.8 23.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users-brainstorm"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9.3h0c.2.2.3.3.3.5V2a.46.46,0,0,1-.4.5.47.47,0,0,1-.5-.5V1c0-.3,0-.6.3-.7Z",
    transform: "translate(-1.4 -0.15)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,6.4a3,3,0,0,1-1,2.5,1.61,1.61,0,0,0-.5,1.1,2,2,0,0,1-1.2,1.9,1.94,1.94,0,0,1-2.6-1.7,2,2,0,0,0-.6-1.5,1,1,0,0,1-.4-.5,3.36,3.36,0,0,1,2.4-5,3.52,3.52,0,0,1,3.8,2.5A5.64,5.64,0,0,0,15.2,6.4Zm-1,0a2.36,2.36,0,0,0-1.4-2.1,2.3,2.3,0,0,0-2.6.4,2.43,2.43,0,0,0-.3,3.5,2.93,2.93,0,0,1,.8,1.9A1,1,0,0,0,12,11a.87.87,0,0,0,.7-1V9.6a2.48,2.48,0,0,1,.8-1.4A2.41,2.41,0,0,0,14.2,6.4Z",
    transform: "translate(-1.4 -0.15)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,2.4l-.1.2-.9.9a.37.37,0,0,1-.6,0,.38.38,0,0,1,0-.6l.9-.9a.44.44,0,0,1,.5-.1A.76.76,0,0,1,16.2,2.4Z",
    transform: "translate(-1.4 -0.15)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,3.8c-.1,0-.2-.1-.3-.2l-.8-.8a.37.37,0,0,1,0-.6.37.37,0,0,1,.6,0l.9.9c.2.1.2.3.1.5A.59.59,0,0,1,8.5,3.8Z",
    transform: "translate(-1.4 -0.15)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_74",
    "data-name": "Capa 74"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.3,16.1h0a3.16,3.16,0,0,1-3.2-3.2A3.22,3.22,0,0,1,6.3,9.7a3.16,3.16,0,0,1,3.2,3.2,3.22,3.22,0,0,1-3.2,3.2ZM4,13a2.22,2.22,0,0,0,2.2,2.2h.2a2.2,2.2,0,0,0-.1-4.4A2.13,2.13,0,0,0,4,13Z",
    transform: "translate(-1.4 -0.15)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,22.5a2.74,2.74,0,0,1-1.3-2.2A2.89,2.89,0,0,1,3,18.1a6.5,6.5,0,0,1,6.6,0,2.74,2.74,0,0,1,1.3,2.2,2.74,2.74,0,0,1-1.3,2.2,6,6,0,0,1-3.3.9A6,6,0,0,1,3,22.5Zm-.4-2.2a1.74,1.74,0,0,0,.9,1.4,5.6,5.6,0,0,0,5.6,0,1.74,1.74,0,0,0,.9-1.4,1.74,1.74,0,0,0-.9-1.4,5.6,5.6,0,0,0-5.6,0A1.74,1.74,0,0,0,2.6,20.3Z",
    transform: "translate(-1.4 -0.15)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_140",
    "data-name": "Capa 140"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.4,15.9h-.1a3.14,3.14,0,0,1-3.1-3.2,3.2,3.2,0,0,1,6.4,0,3.36,3.36,0,0,1-3.2,3.2Zm-2.3-3.2a2.22,2.22,0,0,0,2.2,2.2h.2a2.2,2.2,0,0,0-.1-4.4A2.24,2.24,0,0,0,15.1,12.7Z",
    transform: "translate(-1.4 -0.15)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,22.2A2.74,2.74,0,0,1,12.7,20,2.89,2.89,0,0,1,14,17.8a6.5,6.5,0,0,1,6.6,0A2.74,2.74,0,0,1,21.9,20a2.89,2.89,0,0,1-1.3,2.2,6,6,0,0,1-3.3.9A5.49,5.49,0,0,1,14,22.2Zm-.4-2.1a1.74,1.74,0,0,0,.9,1.4,5.6,5.6,0,0,0,5.6,0,1.74,1.74,0,0,0,.9-1.4,1.74,1.74,0,0,0-.9-1.4,5.6,5.6,0,0,0-5.6,0A2,2,0,0,0,13.6,20.1Z",
    transform: "translate(-1.4 -0.15)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.4 -0.15)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.4 -0.15)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersBrainstorm);
export default __webpack_public_path__ + "static/media/users-brainstorm.651b61d9d4d8bcc77f66dbc2815fbcb4.svg";
export { ForwardRef as ReactComponent };